import { Theme } from '@mui/material'
import { IAddress } from '../store/Address'

export function getWaterSourceFullText(code: string) {
  const waterSourceMap = {
    SW: 'Surface Water',
    GW: 'Groundwater',
    SWP: 'Surface Water Purchase',
    GWP: 'Groundwater Purchase',
    GUDI: 'Groundwater Under the Direct Influence of Surface Water',
    SP: 'Spring',
    WL: 'Well',
    RIV: 'River',
  }

  return waterSourceMap[code] || 'Unknown Source Code'
}

export const getViolationColor = (totalViolations: number, theme: Theme): string => {
  if (totalViolations === 0) return theme.palette.info.main          // All good
  if (totalViolations <= 30) return theme.palette.warning.main       // Some concern
  return theme.palette.error.dark                                    // Serious concern
}

export const getPinColor = (totalViolations: number, theme: Theme): string => {
  if (totalViolations < 15) return '#003E63'
  if (totalViolations <= 30) return '#669BBB'   
  return '#003E63'
  // return '#50EFFF'
}

export function generateLocationTitle(
  selectedState: string | null,
  selectedCounty: string | null,
  selectedZipCode: string | null,
  selectedGeoBlock: string | null,
  selectedAddress: IAddress | null,
): string {
  if (!selectedState && !selectedCounty && !selectedZipCode && !selectedGeoBlock && !selectedAddress) {
    return 'USA'
  }

  if (selectedAddress) {
    return `${selectedAddress.region}, (${selectedAddress.place})`
  }

  if (selectedCounty && selectedZipCode) {
    return `${selectedCounty}, (${selectedZipCode})`
  }

  if (selectedState && selectedZipCode) {
    return `${selectedState}, (${selectedZipCode})`
  }

  if (selectedZipCode && !selectedCounty) {
    return `${selectedState || 'USA'}, (${selectedZipCode})`
  }

  if (selectedCounty && selectedGeoBlock) {
    return `${selectedCounty}, (${selectedGeoBlock})`
  }

  if (selectedCounty && !selectedZipCode) {
    return selectedCounty
  }

  if (selectedState && !selectedCounty) {
    return selectedState
  }

  return 'USA'
}
